import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section id="articles" className="py-16 md:py-24 bg-background-100">
      <div className="container-custom">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-100">
              精选文章
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-2">
              深入探索欲望与自我的关系
            </p>
          </div>
          <Link
            to="/category/shen-ceng-yu-wang"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 mt-3 sm:mt-0 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article, i) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="card-dark group cursor-pointer overflow-hidden"
            >
              <div className="relative h-48 md:h-52 overflow-hidden rounded-md mb-4">
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                  style={{ backgroundImage: `url(${article.image})` }}
                  role="img"
                  aria-label={article.title}
                />
              </div>

              <span className="inline-block text-xs px-2.5 py-1 rounded-full bg-accent-500/10 text-accent-400 mb-3 font-label">
                {article.categoryName}
              </span>

              <h3 className="text-base md:text-lg font-semibold text-foreground-200 font-heading mb-2 group-hover:text-primary-400 transition-colors duration-300 line-clamp-2">
                {article.title}
              </h3>

              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-4">
                {article.summary}
              </p>

              <div className="flex items-center justify-between text-xs text-foreground-600">
                <span>{article.author}</span>
                <div className="flex items-center gap-3">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}